module.exports = __webpack_public_path__ + "static/media/monitor.30e2c51d.png";